import React, { Component } from 'react';
import { Route, Routes } from 'react-router';
import { AppBody } from './components/AppBody';
import Home from './components/Home';
//import Route from './components/api-authorization/Route';
//import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
//import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import Login from './components/auth/Login';
import Session from './components/auth/Session';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';
import { Roles } from './components/admin/Roles';
import { CreateRole } from './components/admin/CreateRole';
import { AccessDenied } from './components/util/AccessDenied';
import './custom.css'
import { Users } from './components/admin/Users';
import { RoleDetails } from './components/admin/RoleDetails';
import UserDetails from './components/admin/UserDetails';
import Admin from './components/admin/Admin';
import SharePointDriverImport from './components/admin/SharePointDriverImport';
import { ForgotPassword } from './components/ForgotPassword';
import { ResetPassword } from './components/ResetPassword';
//import { DriverImport } from './components/DriverImport';
//import { CustomerImport } from './components/CustomerImport';
import { PaysheetData } from './components/PaysheetData';
import { DriverRouteData } from './components/DriverRouteData';
import ManagerDailyRoutes from './components/layout/manager/ManagerDailyRoutes';
import ManagerRoutes from './components/layout/manager/ManagerRoutes';
import InvoiceReview from './components/layout/finance/InvoiceReview';
import InvoiceAudit from './components/layout/finance/InvoiceAudit';
import PaysheetReview from './components/layout/finance/PaySheetReview';
import PaysheetAudit from './components/layout/finance/PaySheetAudit';
import DriverDaysWorkedTotals from './components/layout/reports/DaysWorked';
import ApprovedInvoicesReport from './components/layout/reports/ApprovedInvoicesReport';
import ApprovedPaySheetsReport from './components/layout/reports/ApprovedPaySheetsReport';
import PaysheetReconciliationReport from './components/layout/reports/PaysheetReconciliationReport';
import InvoiceReconciliationReport from './components/layout/reports/InvoiceReconciliationReport';

function App() {
    return (
        <AppBody>
            <Routes>
                <Route exact path='/' element={<Home />} />
                {/*<Route path='/login' component={Login} />*/}
                <Route path='/forgotpassword' element={<ForgotPassword />} />
                <Route path='/resetpassword' element={<ResetPassword />} />
                <Route exact path='/admin' element={<Admin />} />
                <Route exact path='/admin/roles' element={<Roles />} />
                <Route exact path='/admin/roles/create' element={<CreateRole />} />
                <Route exact path='/admin/roles/details' element={<RoleDetails />} />
                <Route exact path='/admin/users' element={<Users />} />
                <Route exact path='/admin/users/details' element={<UserDetails />} />
                <Route exact path='/admin/sharepoint-drivers' element={<SharePointDriverImport />} />
                <Route exact path='/accessdenied' element={<AccessDenied />} />
                {/*<Route exact path='/driverimport' element={<DriverImport />} />*/}
                {/*<Route exact path='/customerimport' element={<CustomerImport />} />*/}
                <Route exact path='/paysheetdata' element={<PaysheetData />} />
                <Route exact path='/driverdata' element={<DriverRouteData />} />
                <Route exact path='/dailyroutes' element={<ManagerDailyRoutes />} />
                <Route exact path='/weeklyroutes' element={<ManagerRoutes />} />
                <Route exact path='/invoices' element={<InvoiceReview />} />
                <Route exact path='/invoiceaudit' element={<InvoiceAudit />} />
                <Route exact path='/paysheets' element={<PaysheetReview />} />
                <Route exact path='/paysheetaudit' element={<PaysheetAudit />} />
                <Route exact path='/daysworked' element={<DriverDaysWorkedTotals />} />
                <Route exact path='/reports/approved-invoices' element={<ApprovedInvoicesReport />} />
                <Route exact path='/reports/approved-paysheets' element={<ApprovedPaySheetsReport />} />
                <Route exact path='/reports/paysheet-reconciliation' element={<PaysheetReconciliationReport />} />
                <Route exact path='/reports/invoice-reconciliation' element={<InvoiceReconciliationReport />} />
                <Route exact path='/reports/invoice-view/:invoiceId' element={<InvoiceAudit readOnly />} />
                <Route exact path='/reports/paysheet-view/:paySheetId' element={<PaysheetAudit readOnly />} />
                {/*<Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />*/}
                <Route exact path='/login' element={<Login />} />
                <Route exact path='/logout' element={<Login action={'logout'} />} />
                <Route exact path='/forgot' render={() => {
                    window.location.href = '/Identity/Account/ForgotPassword';
                    return <></>;
                }} />
            </Routes>
        </AppBody>
    );
}

export default App;
